import { Route } from "@angular/router";
import { GuiaDoUsuarioPage } from "./guia-do-usuario.page";

export const GuiaDoUsuarioRouter: Route[] = [
  { path: 'guia-do-usuario', component: GuiaDoUsuarioPage }
];
